import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const approval = {
  path: '/approval/',
  name: 'approval',
  component: LayoutWithSideMenu,
  meta: {
    title: '审批管理'
  },
  children: [
    {
      path: 'task/todo',
      name: 'todo',
      component: () => import('@/views/approval/task/todo.vue'),
      meta: {
        title: '待办列表'
      }
    },
    {
      path: 'task/operator',
      name: 'operator',
      component: () => import('@/views/approval/task/operator.vue'),
      meta: {
        title: '任务办理'
      }
    },
    {
      path: 'task/done',
      name: 'done',
      component: () => import('@/views/approval/task/done.vue'),
      meta: {
        title: '已办任务'
      }
    },
    {
      path: 'task/received',
      name: 'received',
      component: () => import('@/views/approval/task/received.vue'),
      meta: {
        title: '已收到的任务'
      }
    },
    {
      path: 'task/launch',
      name: 'launch',
      component: () => import('@/views/approval/task/launch.vue'),
      meta: {
        title: '我发起的流程'
      }
    },
    {
      path: 'task/all',
      name: 'all',
      component: () => import('@/views/approval/task/all.vue'),
      meta: {
        title: '全部任务管理'
      }
    },
    {
      path: 'workflow/complex-model',
      name: 'complex-model',
      component: () => import('@/views/approval/workflow/complex.vue'),
      meta: {
        title: '高级流程模型'
      }
    },
    {
      path: 'workflow/definition',
      name: 'workflow-definition',
      component: () => import('@/views/approval/workflow/definition.vue'),
      meta: {
        title: '流程定义管理'
      }
    },
    {
      path: 'workflow/model',
      name: 'workflow-model',
      component: () => import('@/views/approval/workflow/model.vue'),
      meta: {
        title: '流程模型管理'
      }
    },
    {
      path: 'workflow/instance',
      name: 'workflow-instance',
      component: () => import('@/views/approval/workflow/instance.vue'),
      meta: {
        title: '流程实例管理'
      }
    },
    {
      path: 'workflow/formMatch',
      name: 'workflow-form-match',
      component: () => import('@/views/approval/workflow/formMatch.vue'),
      meta: {
        title: '表单流程匹配'
      }
    },
    {
      path: 'workflow/thirdparty',
      name: 'workflow-thridparty',
      component: () => import('@/views/approval/workflow/thirdparty.vue'),
      meta: {
        title: '第三方系统管理'
      }
    },
    {
      path: 'workflow/callback',
      name: 'workflow-thridparty-callback',
      component: () => import('@/views/approval/workflow/callback.vue'),
      meta: {
        title: '第三方系统回调'
      }
    }
  ]
}
